import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { PollConfig } from '../../models';
import {
  continueOngoingPoll,
  pollAction,
  removePoll,
  startPolling,
  updateExtractId,
  updatePollStatus,
  userCancel,
} from '../actions/polling.actions';

export type State = EntityState<PollConfig>;

export const adapter: EntityAdapter<PollConfig> = createEntityAdapter<PollConfig>();

export const initialState: State = adapter.getInitialState({});

export const pollsReducer = createReducer(
  initialState,
  on(continueOngoingPoll, startPolling, (state, action) => adapter.addOne(action.poll, state)),
  on(pollAction, (state, action) => adapter.updateOne({ id: action.poll.id, changes: action.poll }, state)),
  on(removePoll, (state, action) => adapter.removeOne(action.id, state)),
  on(updatePollStatus, (state, action) => adapter.updateOne({ id: action.id, changes: { status: action.status } }, state)),
  on(updateExtractId, (state, action) => adapter.updateOne({ id: action.id, changes: { extractId: action.extractId } }, state)),
  on(userCancel, (state, action) => adapter.updateOne({ id: action.id, changes: { userCancelled: true } }, state)),
);

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
